import axios from 'axios';

// POST /admin/token/:tokenId/revoke — deletes an UNSTARTED assignment (status 1), returning
// the token to the sponsor's pool. Backend blocks booked/assessed tokens (409); the message
// is surfaced to the admin.
export async function revokeToken(tokenId) {
  try {
    const res = await axios.post(`/admin/token/${tokenId}/revoke`);
    return { ok: res.data && res.data.status === 'SUCCESS' };
  } catch (error) {
    const data = error.response && error.response.data;
    return { ok: false, message: (data && data.status_message) || 'Failed to revoke token.' };
  }
}
